export default __webpack_public_path__ + "static/bitcoin-mobile-d320c71bbef552f14cfe7ca20e40ff25.svg";